import * as fromDatatype from '../datatype-library/index';

export interface bl_pgw_merchant_rate_card_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    rate_card_guid: fromDatatype.GuidDataFieldInterface;
    contract_guid: fromDatatype.GuidDataFieldInterface;
    merchant_contract_key: fromDatatype.VarcharDatatypeInterface;
    admin_status: fromDatatype.VarcharDatatypeInterface;
    merchant_status: fromDatatype.VarcharDatatypeInterface;
    application_status: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    payment_provider_code: fromDatatype.VarcharDatatypeInterface;
    nickname: fromDatatype.VarcharDatatypeInterface;
}
export class bl_pgw_merchant_rate_card_line_RowClass implements bl_pgw_merchant_rate_card_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    rate_card_guid: fromDatatype.GuidDataFieldInterface;
    contract_guid: fromDatatype.GuidDataFieldInterface;
    merchant_contract_key: fromDatatype.VarcharDatatypeInterface;
    admin_status: fromDatatype.VarcharDatatypeInterface;
    merchant_status: fromDatatype.VarcharDatatypeInterface;
    application_status: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    payment_provider_code: fromDatatype.VarcharDatatypeInterface;
    nickname: fromDatatype.VarcharDatatypeInterface;
}
